//import API from "../../../services/apiservices";

export default {
  namespaced: true,

  state: {
    romaneios: {
      data: [{ item: "Nenhum registro encontrado" }],
    },
  },

  getters: {
    getromaneios: (state) => state.romaneios.data,
  },

  mutations: {
    setromaneios: (state, romaneios) => (state.romaneios.data = romaneios),
  },

  actions: {
    actromaneios() {
      //console.log("actromaneios:hit");
      // API.get("Transportadoras/Romaneios/Get", {
      //   params: { database: new Date() },
      // }).then((apidata) => {
      //   const data = API.prepareData(apidata.data);
      //   commit("setromaneios", data);
      // });
    },
  },
};
